import { motion, AnimatePresence, useInView, stagger, useAnimate, DynamicOption } from 'framer-motion';
import { StackedContent, MotionImage, useSanitizedTranslation, TextBlock } from 'ui';
import { useState, useRef, useEffect } from 'react';
import Image from 'next/image';

export interface IconTabs {
  title: string;
  icons: string[];
}

export interface PartnerIconProps {
  bg: string;
  copy: any;
  icontabs: IconTabs[];
}

export interface StickyIconProps {
  item: any;
  trigger: any;
  state: number;
  index: number;
}

function getElementTopPosition(elem: any) {
    var box = elem.getBoundingClientRect();
  
    var body = document.body;
    var docEl = document.documentElement;
  
    var scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
    var scrollLeft = window.pageXOffset || docEl.scrollLeft || body.scrollLeft;
  
    var clientTop = docEl.clientTop || body.clientTop || 0;
    var clientLeft = docEl.clientLeft || body.clientLeft || 0;
  
    var top = box.top + scrollTop - clientTop;
    var left = box.left + scrollLeft - clientLeft;
  
    return top;
  }


const StickyIcons = ({ item, trigger, state, index }: StickyIconProps) => {

  const animref = useRef(null);
  const inView = useInView(animref, { margin: '-30% 0% -30% 0%' });
  
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0 },
    visible: { opacity: 1 },
  };

  useEffect(() => {
    if (inView) {
      trigger(index)
    }
  }, [inView]);

  return (
    <div ref={animref} className="relative w-full z-10 flex flex-col items-center text-center max-lg:py-8 lg:-translate-y-1/2 last-of-type:lg:translate-y-1/4">
      <motion.div 
      id={'sticky-icons' + index} 
      className='flex flex-row items-center justify-center flex-wrap gap-2'
      variants={containerVariants}
      initial="hidden"
      animate={inView ? 'visible' : 'hidden'}
      >
        {item.map((icon: any, index: number) => (
          <motion.div 
            className='aspect-[16/7] overflow-hidden rounded-xl shadow-xl w-[16vw] max-w-[275px] h-auto' 
            key={state + 'img' + index + icon} 
            style={{backgroundImage: `url(${icon})`, backgroundSize: 'cover', backgroundPosition: 'center'}}
            variants={itemVariants}
          >
          </motion.div>
        ))}
      </motion.div>
    </div>
  );
};

export const PartnerIcons = ({ icontabs, copy, bg='white'}: PartnerIconProps) => {

    const [activeState, setState] = useState(0);

    return (
        <motion.section className="pt-[30rem] w-full relative z-40 items-center" data-testid={'text-section'} style={{background: bg}}>
        {/* Sticky Image and Text */}
        <div className="wrapper lg:-mb-[150px] xl:-mb-[200px] 2xl:-mb-[240px]">
          <div className="flex gap-8">
              <div className={`flex items-start justify-center max-lg:hidden lg:basis-4/12`}>
              <div className="top-[55vh] -mt-4 flex w-full items-center justify-center lg:sticky">
                  <motion.div
                  className="relative lg:-left-[5%] lg:min-w-[120%] lg:-translate-y-1/2 bg-white rounded-lg py-16 px-10 h-max"
                  >
                      <div className="object-clip w-[98%] flex flex-col gap-2 items-center justify-center">
                          <StackedContent
                              full
                              center
                              noOrphans
                              content={copy}
                          />
                          {icontabs.map((item, index) => (
                            <div
                              onClick={() => {
                                // scroll
                                window.scrollTo(0, getElementTopPosition(document.getElementById('sticky-icons'+index)) - (window.innerHeight / 2 - 60) - 25)
                                // make btn active
                                setState(index)
                              }}
                              data-i18n={item.title}
                              className={
                              (activeState === index ? 'weight-600 text-black outline-xumoTeal' : 'cursor-pointer text-xumoCharcoal outline-transparent hover:text-xumoBlack') +
                              ' no-shift rounded-full px-4 py-1 outline outline-2 max-lg:my-2'
                              }
                            >
                              {item.title}
                            </div>
                          ))}
                      </div>
                  </motion.div>
              </div>
              </div>

              <div className="relative z-10 flex w-full flex-col items-center text-center lg:basis-8/12 lg:space-y-[50vh] pb-[65vh]">
              {icontabs.map((item, index) => (
                  <StickyIcons key={'sticky-icon-section' + index} item={item.icons} state={activeState} index={index} trigger={() => setState(index)} />
              ))}
              </div>
            </div>
        </div>
        </motion.section>
    );
};
